export const DELIVERY_SERVICE_LEVELS = [
  {
    code: 'classic',
    label: 'Clásico',
    price: 9.9,
    priceLabel: 'S/ 9.90',
    shortDescription: 'Entrega Fast Max estándar.',
    bullets: ['Registro simple', 'Comunicación operativa', 'COD disponible'],
  },
  {
    code: 'coordinated',
    label: 'Coordinado',
    price: 14.9,
    priceLabel: 'S/ 14.90',
    shortDescription: 'Más coordinación para casos sensibles.',
    bullets: ['Coordinación avanzada', 'Preferencia horaria', 'Reintento extra'],
  },
  {
    code: 'premium',
    label: 'Premium',
    price: 19.9,
    priceLabel: 'S/ 19.90',
    shortDescription: 'Mayor resolución operativa Fast Max.',
    bullets: ['Mayor prioridad', 'Conductor experto', 'Seguimiento reforzado'],
  },
];

export const DELIVERY_ADDONS = [
  {
    code: 'extra_retry_pre_registration',
    aliases: ['reintento_preventivo'],
    label: 'Reintento preventivo',
    price: 3,
    priceLabel: '+ S/ 3.00',
    description: 'Un intento adicional seleccionado antes de registrar la entrega.',
  },
];

export function getServiceLevel(code) {
  return DELIVERY_SERVICE_LEVELS.find(service => service.code === code) || DELIVERY_SERVICE_LEVELS[0];
}

export function getAddon(code) {
  return DELIVERY_ADDONS.find(addon => addon.code === code || addon.aliases?.includes(code));
}

export function normalizeServiceCode(value, fallback = 'classic') {
  const raw = (value || '').toString().trim().toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

  const aliases = {
    clasico: 'classic',
    classic: 'classic',
    basico: 'classic',
    estandar: 'classic',
    coordinado: 'coordinated',
    coordinada: 'coordinated',
    coordinated: 'coordinated',
    premium: 'premium',
    pro: 'premium',
  };

  const code = aliases[raw] || raw;
  return DELIVERY_SERVICE_LEVELS.some(service => service.code === code) ? code : fallback;
}

export function normalizeAddonCodes(value) {
  if (!value) return [];
  const values = Array.isArray(value)
    ? value
    : value.toString().split(/[,;|]+/);

  const normalized = [];
  values.forEach(item => {
    const raw = (item || '').toString().trim().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
    if (!raw) return;
    const addon = DELIVERY_ADDONS.find(candidate =>
      candidate.code === raw || candidate.aliases?.includes(raw)
    );
    if (addon && !normalized.includes(addon.code)) {
      normalized.push(addon.code);
    }
  });
  return normalized;
}

export function calculateDeliveryPricing(serviceCode = 'classic', addonCodes = []) {
  const service = getServiceLevel(normalizeServiceCode(serviceCode));
  const normalizedAddons = normalizeAddonCodes(addonCodes);
  const addons = normalizedAddons.map(getAddon).filter(Boolean);
  const total = addons.reduce((sum, addon) => sum + addon.price, service.price);

  return {
    service,
    addons,
    addonCodes: addons.map(addon => addon.code),
    total,
    totalLabel: `S/ ${total.toFixed(2)}`,
  };
}

